export * from './validation-pattern.const';
